import BaseDataObject from './BaseDataObject';

export default class Horse extends BaseDataObject {
  getName() {
    return this.getString('name');
  }

  getSex() {
    return this.getObject('sex', HorseSex);
  }

  getAge() {
    return this.getInteger('age');
  }

  getAtgHorseId() {
    return this.getInteger('atgHorseId');
  }
}

class HorseSex extends BaseDataObject {
  getCode() {
    const rawCode = this.getString('code');

    // Some codes from Norwegian API need to be modified
    if (IS_NO_SITE) {
      if (rawCode === 'Hpf') {
        return 'Hp';
      }
      if (rawCode === 'Hf') {
        return 'H';
      }
    }

    return rawCode;
  }

  getDescription() {
    return this.getString('domesticText');
  }
}
